import { render, staticRenderFns } from "./UpdateLogisticsList.vue?vue&type=template&id=2c7b8d77"
import script from "./UpdateLogisticsList.vue?vue&type=script&lang=js"
export * from "./UpdateLogisticsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports